import React from 'react';

// Mini calendrier mensuel (Lun → Dim) pour sélectionner un jour disposant de données
export default function DayCalendar({ month, selected, onSelect, enabledDays, testPrefix = 'sheet-day' }) {
    const [y, m] = month.split('-').map(Number);
    const offset = (new Date(y, m - 1, 1).getDay() + 6) % 7; // lundi = 0
    const lastDay = new Date(y, m, 0).getDate();
    const cells = [...Array(offset).fill(null), ...Array.from({ length: lastDay }, (_, i) => i + 1)];
    while (cells.length % 7) cells.push(null);
    const rows = [];
    for (let i = 0; i < cells.length; i += 7) rows.push(cells.slice(i, i + 7));
    const isoOf = (dn) => `${month}-${String(dn).padStart(2, '0')}`;

    return (
        <div className="inline-block border rounded-lg bg-white p-2 shadow-sm" data-testid={`${testPrefix}-selector`}>
            <table className="border-separate" style={{ borderSpacing: 2 }}>
                <thead>
                    <tr>
                        {['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'].map(dn => (
                            <th key={dn} className="text-[10px] font-semibold text-slate-400 w-9 pb-0.5">{dn}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, ri) => (
                        <tr key={ri}>
                            {row.map((dn, ci) => {
                                if (!dn) return <td key={ci} />;
                                const iso = isoOf(dn);
                                const ok = enabledDays.includes(iso);
                                return (
                                    <td key={ci}>
                                        <button
                                            onClick={() => ok && onSelect(iso)}
                                            disabled={!ok}
                                            className={`w-9 h-8 rounded-md text-xs font-semibold transition-colors ${selected === iso
                                                ? 'bg-teal-700 text-white'
                                                : ok
                                                    ? 'bg-slate-50 hover:bg-teal-100 text-slate-700 border border-slate-200'
                                                    : 'text-slate-300 cursor-default'}`}
                                            data-testid={`${testPrefix}-${iso}`}>
                                            {dn}
                                        </button>
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
